<template>
    <div class="inform-list-content">
        <!-- 1. 通知列表 -->
        <virtual-list
            v-show="!!informList.length"
            id="FamousInformList"
            class="overflow-y-scroll scroll-touch"
            :data-key="'id'"
            :data-sources="informList"
            :data-component="itemComponent"

            :estimate-size="30"
            :footer-class="'famous-list-note'"
            v-on:tobottom="onScrollToBottom">
            <div v-show="parseInt(informData.nowpage) < parseInt(informData.totalpage)" slot="footer" class="lds-dual-ring lds-dual-ring-gray"></div>
        </virtual-list>
        <!-- 2. 无通知数据 -->
        <no-data
            v-show="!informList.length"
            v-bind:noteText="'暂无通知~'">
        </no-data>
    </div>
</template>

<script>
import InformItem from '../../components/InformItem.vue'
import NoData from '../../components/common/NoData.vue'
export default {
    name: 'InformVirtualList',
    components: { InformItem, NoData },
    props: {
        informList: {
            type: Array,
            default() { return [] }
        },
        informData: {
            type: Object,
            default() { return {} }
        }
    },
    data() {
        return {
            itemComponent: InformItem
        }
    },
    methods: {
        onScrollToBottom() {
            var me = this;
            this.$store.dispatch('inform/updateMsgList')
        }
    }
}
</script>